import * as Factory from 'factory.ts'
import faker from 'faker'

import { type PurchaseOrderItemSummary } from '@webapp/models/PurchaseOrderItemSummary'

export const PurchaseOrderItemSummaryMock =
  Factory.Sync.makeFactory<PurchaseOrderItemSummary>({
    billed_quantity: Factory.each(() => faker.random.number(10)),
    billed_cost: Factory.each(() =>
      faker.random.number({ max: 100, precision: 2 })
    ),
    purchased_cost: Factory.each(() =>
      faker.random.number({ max: 10000, precision: 2 })
    ),
    purchased_quantity: Factory.each(() => faker.random.number(100000)),
    received_cost: Factory.each(() =>
      faker.random.number({ max: 9000, precision: 2 })
    ),
    received_quantity: Factory.each(() => faker.random.number(10)),
    recurrence: null,
  })
